module.exports = __webpack_public_path__ + "img/sincerity.90ceb736.png";